<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <p class=".title ma-2"> {{hsct.eign_naam }} </p>
            <v-simple-table>
                <template v-slot:default>
                    <tbody>
                        <tr v-for="(nttp,i) in hsct.nttp" :key="i"> 
                            <td>
                                <v-checkbox v-model="nttp.hctn" :label="nttp.nttptaal_oms"></v-checkbox>
                            </td> 
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="saveHsct">Save</v-btn>
                <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,
                hsct_encrid: null,
                hsct: {}
            }
        },
        methods: {
            open(hsct_encrid) {
                this.$emit("showSnackbar");
                this.dialog = true;
                this.$axios.post("ares/json/ares/huis/hsct/getHsct.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHsct"
                    },
                    getHsct: {
                        hsct_encrid: hsct_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hsct = res.data.getHsct;
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            saveHsct() { 
                this.$axios.post("ares/json/ares/huis/hsct/saveHsct.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveHsct"
                    },
                    saveHsct: {
                        hsct_encrid: this.hsct.hsct_encrid,
                        hsct: this.hsct
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else { 
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.saveHsct.text,
                            color: res.data.saveHsct.color
                        }); 
                        this.$emit('updateData');
                        this.dialog = false;
                    }
                })
            },
        }
    }
</script>
